import type { CustomChartSerie } from "@tokenterminal/tt-analytics-api-types/dist/api/customChart"
import { twMerge } from "tailwind-merge"
import { Symbol } from "./Symbol"

export type LegendItemProps = {
  serieType: CustomChartSerie["chart_type"]
  color: string
  name: string
  isActive: boolean
  onClick?: () => void
  onMouseOver?: () => void
  onMouseOut?: () => void
}

export function LegendItem({
  serieType,
  color,
  name,
  onClick,
  onMouseOut,
  onMouseOver,
  isActive,
}: LegendItemProps) {
  return (
    <div
      className={twMerge(
        "flex gap-2 items-center justify-start",
        onClick && "cursor-pointer",
        isActive ? "opacity-100" : "opacity-50"
      )}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <Symbol serieType={serieType} color={color} />
      <div className="text-fg-default text-xs whitespace-nowrap">{name}</div>
    </div>
  )
}
